export default "__VITE_ASSET__DPc7Zj8j__"